import httpClient from '../httpClient';

const info = async (id) => {
  return await httpClient.get(`/mass_modification_responsibility/${id}/info/`);
};

const post = async (data) => {
  return await httpClient.post('/mass_modification_responsibility/', data);
};

const patch = async (id, data) => {
  return await httpClient.patch(
    `/mass_modification_responsibility/${id}/`,
    data,
  );
};

const remove = async (id) => {
  return await httpClient.delete(`/mass_modification_responsibility/${id}/`);
};

const renumerate = async (modificacion_id) => {
  return await httpClient.post(
    '/mass_modification_responsibility/renumerate/',
    {
      mm: modificacion_id,
    },
  );
};
const swap = async (a, b) => {
  return await httpClient.post('/mass_modification_responsibility/swap/', {
    a: a,
    b: b,
  });
};

const move = async (id, data) => {
  return await httpClient.patch(
    `/mass_modification_responsibility/${id}/move/`,
    data,
  );
};

const view_home = async (query, page = 1, pageSize = 10, search = false) => {
  return await httpClient.get(
    `/mass_modification_responsibility/view_home/?page[number]=${page}&page[size]=${pageSize}&filter[modulo_modificacion]=${query}${
      search ? `&filter[search]=${search}` : ''
    }`,
  );
};

const filter = async (
  query,
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/mass_modification_responsibility/export/?filter[modulo_modificacion]=${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/mass_modification_responsibility/?page[number]=${page}&page[size]=${pageSize}&filter[modulo_modificacion]=${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

const preview = async (
  query,
  page = 1,
  pageSize = 10,
  _sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  if (exportCSV)
    return await httpClient.get(
      `/mass_modification_responsibility/export_preview/?filter[modulo_modificacion]=${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/mass_modification_responsibility/preview/?page[number]=${page}&page[size]=${pageSize}&filter[modulo_modificacion]=${query}${
        search ? `&filter[search]=${search}` : ''
      }`,
    );
};

const patchModule = async (id, data) => {
  return await httpClient.patch(
    `/mass_modification_responsibility/${id}/update_module/`,
    data,
  );
};

export {
  info,
  post,
  patch,
  remove,
  filter,
  swap,
  preview,
  view_home,
  patchModule,
  renumerate,
  move,
};
